import axios from 'axios';

const baseURL = import.meta.env.VITE_API_URL || import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000';

export const api = axios.create({
  baseURL,
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('tiendaya_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      const refreshToken = localStorage.getItem('tiendaya_refresh_token');
      if (refreshToken) {
        try {
          const { data } = await api.post('/api/auth/token/refresh/', {
            refresh: refreshToken
          });
          
          if (data.access) {
            localStorage.setItem('tiendaya_token', data.access);
            originalRequest.headers.Authorization = `Bearer ${data.access}`;
            return api(originalRequest);
          }
        } catch {
          // Refresh failed, clear BOTH tokens
          localStorage.removeItem('tiendaya_token');
          localStorage.removeItem('tiendaya_refresh_token');
        }
      } else {
        // No refresh token, clear access token
        localStorage.removeItem('tiendaya_token');
      }
    }
    
    return Promise.reject(error);
  }
);

export function setAuthToken(token: string | null, refreshToken?: string | null) {
  if (token) {
    localStorage.setItem('tiendaya_token', token);
  } else {
    localStorage.removeItem('tiendaya_token');
    localStorage.removeItem('tiendaya_user'); // Limpiar info del usuario
  }
  
  if (refreshToken !== undefined) {
    if (refreshToken) {
      localStorage.setItem('tiendaya_refresh_token', refreshToken);
    } else {
      localStorage.removeItem('tiendaya_refresh_token');
    }
  }
}
